export const SPREADSHEET_KEY_RE = '[a-zA-Z0-9-_]{44}';
